/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react'
import Button from '@mui/material/Button'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { clearFormStatus } from '../../../irmlib/src/redux'

// Define styled component outside of the functional component
const TextButton = styled(Button)`
  && {
    width: 19vw;
    // padding: 17px 0 0 0;
    justify-content: flex-start;
    padding-left: 0
  }
`
const NameLabel = styled.label`
    display: flex;
    width: 12vw;
    justify-content: left;
    color: #2E8B57;
`
const ErrorLabel = styled.label`
    display: flex;
    justify-content: flex-start;
    color: red;
    font-size: 11px;
    margin-right: 10px;
`
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
})

// Function to check if the file size exceeds the specified limit dynamically
export const doesFileSizeExceed = (fileSize, maxFileSize) => {
  if (fileSize > maxFileSize) {
    return true
  } else {
    return false
  }
}

export const InputFileUploadButton = (props) => {
//   const [selectedImage, setSelectedImage] = useState(null)
  const { t } = useTranslation()
  const { onImageCapture, error, setError, maxSize, allowedFormats, prevRefImage, resetTrigger } = props
  const addRefImg = prevRefImage || null
  const [selectedImageLabel, setSelectedImageLabel] = useState(null)
  // console.log(addRefImg, selectedImageLabel, 'ref')
  const [fileError, setFileError] = useState(null)

  useEffect(() => {
    // This effect runs every time resetTrigger changes (i.e., when the Reset button is clicked)
    if (resetTrigger > 0) {
      setFileError(null)
      setSelectedImageLabel(null)
      onImageCapture(null)
      clearFormStatus()
    }
  }, [resetTrigger])

  const handleImageChange = (event) => {
    if (event?.target?.files[0]?.length !== 0 && event?.target?.files[0] !== undefined) {
      const file = event.target.files[0]
      const maxSizeInBytes = maxSize * 1024 * 1024 // coverting file size in bytes
      const isFileSizeExceeded = doesFileSizeExceed(file.size, maxSizeInBytes)
      const fileType = file.type.toLowerCase()
      const fileName = file.name.toLowerCase()
      if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg' && isFileSizeExceeded) {
        setFileError(t('demo.uploadJpgTypeandSizeErr', { noOfMb: maxSize }))
        setSelectedImageLabel(null)
        onImageCapture(null)
        clearFormStatus()
      } else if (allowedFormats.includes('JPG') && allowedFormats.includes('JPEG') && !fileName.endsWith('.jpg') && !fileName.endsWith('.jpeg') && fileType !== 'image/jpeg') {
        setFileError(t('demo.uploadJpgType'))
        setSelectedImageLabel(null)
        onImageCapture(null)
        clearFormStatus()
      } else if (isFileSizeExceeded) {
        setFileError(t('demo.fileSizeExceeded', { noOfMb: maxSize }))
        setSelectedImageLabel(null)
        onImageCapture(null)
        clearFormStatus()
      } else {
        setSelectedImageLabel(file.name)
        onImageCapture(file)
        setError('')
        setFileError(null)
        clearFormStatus()
      }
    } else {
      return null
    }
  }
  return (
    <div>
      <TextButton 
    //   onClick={handleUploadButtonClick}
        component="label"
        role={undefined}
        tabIndex={-1}
    >{`${t('buttons.addReference')} `}
        <VisuallyHiddenInput 
          type="file" 
          accept="image/*"
          onChange={handleImageChange}
        />
      </TextButton>
      {selectedImageLabel || addRefImg 
        ? <NameLabel>{selectedImageLabel || addRefImg}</NameLabel>
        : null}
      {(error || fileError) && <ErrorLabel>{error || fileError}</ErrorLabel>}
    </div>
  )
}
InputFileUploadButton.propTypes = {
  onImageCapture: PropTypes.func,
  error: PropTypes.string,
  setError: PropTypes.func.isRequired
}

InputFileUploadButton.defaultProps = {
  onImageCapture: null,
  error: null,
  setError: () => {}
}